import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import { useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import useActivityInfo from '@/app/[locale]/new/(products)/[productType]/[...slug]/components/hooks/useActivityInfo';
const CANCELLATION_POLICY = {
    NO_REFUND: 10,
    HOURS_24: 20,
    HOURS_48: 30,
    DAYS_7: 40,
    DAYS_30: 50,
};
export default function CancellationPolicy({ selectedDate }) {
    const { cancellationPolicy } = useActivityInfo();
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);
    const freeCancellationTime = useMemo(() => {
        if (!isMounted || !(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.date) || !(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.startTime) || !(cancellationPolicy === null || cancellationPolicy === void 0 ? void 0 : cancellationPolicy.seconds)) {
            return null;
        }
        const activityDateTime = dayjs(`${selectedDate.date} ${selectedDate.startTime}`);
        const deadline = activityDateTime.subtract(cancellationPolicy.seconds, 'second');
        if (deadline.isBefore(dayjs())) {
            return null;
        }
        return deadline;
    }, [isMounted, selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.date, selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.startTime, cancellationPolicy === null || cancellationPolicy === void 0 ? void 0 : cancellationPolicy.seconds]);
    const getCancellationMessage = () => {
        if (!cancellationPolicy)
            return null;
        switch (cancellationPolicy.value) {
            case CANCELLATION_POLICY.NO_REFUND:
                return (_jsx(FormattedMessage, { id: 'a/vlHz', defaultMessage: 'Cancellation - {cancellation}', values: { cancellation: cancellationPolicy.title } }));
            default:
                if (freeCancellationTime) {
                    const isActivityDay = freeCancellationTime.format('YYYY-MM-DD') === (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.date);
                    if (isActivityDay) {
                        return (_jsx(FormattedMessage, { id: 'czDCJp', defaultMessage: 'Free cancellation until {time} on activity day', values: {
                                time: dayjs(`${selectedDate.date} ${selectedDate.startTime}`).format('HH:mm'),
                            } }));
                    }
                    else {
                        return (_jsx(FormattedMessage, { id: 'fEjq/Q', defaultMessage: 'Free cancellation until {time} on {date}', values: {
                                time: freeCancellationTime.format('HH:mm'),
                                date: freeCancellationTime.format('MMM D, YYYY'),
                            } }));
                    }
                }
                else {
                    return (_jsx(FormattedMessage, { id: 'D66Fli', defaultMessage: 'Free cancellation - {cancellation} notice!', values: { cancellation: cancellationPolicy.title } }));
                }
        }
    };
    return (_jsx(Typography, { sx: { fontWeight: 600, color: '#0070D3', fontSize: '14px', textAlign: 'center' }, children: getCancellationMessage() }));
}
